

import { GET_ALL_CASE_FILTER} from '../types'

const INITIAL_STATE = {
  allFilterCase: []
  
}

const excelUploadReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_CASE_FILTER:
      return {
        ...state,
        allFilterCase: payload.data,
      }

    default:
      return state
  }
}

export default excelUploadReducer
